export const FILE_PATH = {
    PRODUCT         : 'filepond/product',
    CATEGORY_BANNER : 'filepond/category_banner',
    ANNOUNCEMENT    : 'filepond/announcement',
    PROFILE         : 'filepond/profile',
    USER_PROFILE    : 'filepond/user_profile',
    CHAT            : 'filepond/chat',
    BLOCK           : 'filepond/block',
    QUIZ            : 'filepond/quiz',
    INTRODUCE_VIDEO : 'filepond/introduce_videos'

}

export const DEFAULT_IMAGE_PATH = {
    PRODUCTS            : "assets/images/default/products/empty.webp",
    COURSE_BANNER       : "assets/images/default/products/loader.jpg",
    PRODUCTS_LIGHT      : "assets/images/default/products/empty-light.webp",
    PRODUCTS_DARK       : "assets/images/default/products/empty-dark.webp",
    AVATAR              : 'assets/images/default/avatars/avatar-default.png',
    BLOCK               : "assets/images/default/blocked/",
    CLASSES             : "assets/images/default/classes/classino_default.jpeg",
    CLASS_BANNER        : "assets/images/default/classes/banner-default.jpg",
    CLASS_LIVE          : "assets/images/default/classes/live-class-banner-play.gif",
    PROFESSORS          : "assets/images/default/professors/professor-default.png",
}
